/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookTimeThreeDsGateResponse
 */
export interface BookTimeThreeDsGateResponse {
    /**
     * True when the booking may proceed with this card; false when it must be refused with the standard card message.
     * @type {boolean}
     * @memberof BookTimeThreeDsGateResponse
     */
    allowed: boolean;
    /**
     * Branch the gate took — one of `account_established` (owning account is >=24h old), `already_verified` (card carries a prior successful 3DS record), `verified_now` (fresh server-side 3DS verification passed), `verify_unavailable` (card cannot complete an off-session verification SetupIntent — allowed, nothing verified), `challenge_required` (issuer insists on a challenge we cannot render server-side, fresh or replayed from the persisted refusal), `challenge_completed` (a pending challenge SetupIntent was re-read from Stripe and succeeded — allowed), `challenge_expired` (a pending challenge SetupIntent is no longer completable, e.g. canceled — refused this attempt, next attempt re-verifies fresh), `fraud_decline` (verification hit a hard fraud decline), or `three_ds_failed` (card carries a prior failed 3DS record).
     * 
     * @type {string}
     * @memberof BookTimeThreeDsGateResponse
     */
    reason: string;
    /**
     * The verification SetupIntent id (`seti_xxx`), when one was involved — returned so a future increment can render the challenge from this refusal.
     * @type {string}
     * @memberof BookTimeThreeDsGateResponse
     */
    setupIntentId?: string | null;
    /**
     * 3DS outcome from the verification (`authenticated`, `failed`, ...), when a fresh verification ran.
     * @type {string}
     * @memberof BookTimeThreeDsGateResponse
     */
    threeDsResult?: string | null;
    /**
     * SetupIntent client secret for rendering the 3DS challenge with Stripe `handleNextAction`. Only set when `allowed` is false with a renderable challenge and the request declared `supports_three_ds_challenge`.
     * 
     * @type {string}
     * @memberof BookTimeThreeDsGateResponse
     */
    clientSecret?: string | null;
}

/**
 * Check if a given object implements the BookTimeThreeDsGateResponse interface.
 */
export function instanceOfBookTimeThreeDsGateResponse(value: object): value is BookTimeThreeDsGateResponse {
    if (!('allowed' in value) || value['allowed'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function BookTimeThreeDsGateResponseFromJSON(json: any): BookTimeThreeDsGateResponse {
    return BookTimeThreeDsGateResponseFromJSONTyped(json, false);
}

export function BookTimeThreeDsGateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookTimeThreeDsGateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allowed': json['allowed'],
        'reason': json['reason'],
        'setupIntentId': json['setup_intent_id'] == null ? undefined : json['setup_intent_id'],
        'threeDsResult': json['three_ds_result'] == null ? undefined : json['three_ds_result'],
        'clientSecret': json['client_secret'] == null ? undefined : json['client_secret'],
    };
}

export function BookTimeThreeDsGateResponseToJSON(json: any): BookTimeThreeDsGateResponse {
    return BookTimeThreeDsGateResponseToJSONTyped(json, false);
}

export function BookTimeThreeDsGateResponseToJSONTyped(value?: BookTimeThreeDsGateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'allowed': value['allowed'],
        'reason': value['reason'],
        'setup_intent_id': value['setupIntentId'],
        'three_ds_result': value['threeDsResult'],
        'client_secret': value['clientSecret'],
    };
}

